import { useRoute } from './router.js';
import { useAuth } from './lib/auth.js';
import { FrontPage } from './routes/FrontPage.js';
import { Login } from './routes/Login.js';
import { AdminPage } from './admin/AdminPage.js';
import { PresenterRoute } from './presenter/PresenterRoute.js';
import { ProducerRoute } from './producer/ProducerRoute.js';

export function App() {
  const { path, navigate } = useRoute();
  const auth = useAuth();

  // --- Public routes (no auth needed) ---
  if (path.startsWith('/presenter')) return <PresenterRoute />;
  if (path === '/login') return <Login navigate={navigate} onLoggedIn={auth.setUser} />;

  // --- Auth-gated routes ---
  if (path.startsWith('/producer') || path.startsWith('/admin')) {
    if (auth.loading) {
      return (
        <div className="wrap" style={{ paddingTop: '3rem' }}>
          <p className="muted">Loading…</p>
        </div>
      );
    }
    if (!auth.user) return <Login navigate={navigate} onLoggedIn={auth.setUser} />;

    if (path.startsWith('/admin')) {
      if (auth.user.role !== 'admin') return <FrontPage navigate={navigate} />;
      return <AdminPage navigate={navigate} user={auth.user} onLogout={() => auth.setUser(null)} />;
    }
    return (
      <ProducerRoute user={auth.user} navigate={navigate} onLogout={() => auth.setUser(null)} />
    );
  }

  // --- Front page ---
  return <FrontPage navigate={navigate} />;
}
